/** Verifica se o nome de rota indicado pertence à mesma secção que
 * "prefixo": ou é exactamente essa rota, ou é uma rota "filha" cujo nome
 * começa por "prefixo-" (convenção desta app: todas as rotas são
 * irmãs/planas, nunca aninhadas, por isso o `active-class` nativo do
 * vue-router não reconhece uma página de detalhes como pertencendo à
 * secção da sua listagem). Usado tanto para permissões (router) como para
 * manter o link do menu activo em qualquer página da secção. */
export function correspondeAoPrefixo(
  nomeRota: string | symbol | null | undefined,
  prefixo: string,
): boolean {
  if (typeof nomeRota !== "string") return false;
  return nomeRota === prefixo || nomeRota.startsWith(`${prefixo}-`);
}
